import React from 'react';

import './bv-empty.scss';

interface IBVEmpty {
    dataSource: any[];
    disclaimer: string;
}

const BVEmpty: React.FunctionComponent<IBVEmpty> = ({ children, dataSource, disclaimer }) => (
    <React.Fragment>
        {dataSource && dataSource.length > 0
            ? children
            :
            <div className="bv-empty-container">
                <span className="disclaimer-heading">
                    {disclaimer ? disclaimer : 'No results found.'}
                </span>
            </div>
        }
    </React.Fragment>
);

export default BVEmpty;